export const keylessColors = {
  green: "#8EC64E",
  orange: '#FD812A',
}

export const errorModalImgStyle = {
  width: '40px',
}

export const bigImageStyle = {
  marginTop: '3rem',
  marginBottom: '3rem',
}

export const bigModalStyle = {
  height: '70dvh',
}

const RENTWAY_MAX_FUEL = 8
const MAX_PERCENTAGE = 100

export function transformFuelPercentageToRwFuel(percentage) {
  const m = (percentage / MAX_PERCENTAGE)
  return Number(RENTWAY_MAX_FUEL * m)
}
